import { ItemAPI } from "@/apis/material";
import { Select } from "@arco-design/web-react";
import { useCallback, useEffect, useState } from "react";
import _ from "lodash";

const ITEM_OPTION_STYLE = {
    name: { fontSize: 14, fontWeight: 600, color: '#1d2129' },
    desc: { fontSize: 12, color: '#86909c' },
};

const renderTwoLineLabel = (itemName, description) => (
    <div style={{ lineHeight: 1.5 }}>
        <div style={ITEM_OPTION_STYLE.name}>{itemName}</div>
        {description && <div style={ITEM_OPTION_STYLE.desc}>{description}</div>}
    </div>
);

const buildItemOptions = (items, twoLine) => _.map(_.orderBy(items, ['itemName'], ['asc']), item => {
    const itemName = item.itemName;
    const description = item.description || "";
    return {
        value: item.id,
        label: twoLine
            ? renderTwoLineLabel(itemName, description)
            : `${itemName}${description ? " / " + description : ""}`,
        extra: { itemName, description },
        itemName,
        description,
        itemNo: item.itemNo,
    };
});

export const ItemSelect = ({ value, onChange, onSelectItem, options, twoLine = true, placeholder = "Select Item", ...props }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (options) {
            setData(options);
            return;
        }
        const load = async () => {
            const result = await ItemAPI.actives();
            setData(buildItemOptions(result, twoLine));
        };
        load();
    }, [options, twoLine]);

    const handleChange = useCallback((val) => {
        if (onSelectItem) {
            const selected = _.find(data, { value: val });
            onSelectItem(selected || null);
        }
        onChange && onChange(val);
    }, [data, onSelectItem, onChange]);

    const filterOption = useCallback((input, option) => {
        if (twoLine) {
            const extra = option.props.extra || {};
            const itemName = extra.itemName || '';
            const desc = extra.description || '';
            return itemName.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                   desc.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }, [twoLine]);

    const triggerProps = twoLine
        ? { autoAlignPopupWidth: false, autoAlignPopupMinWidth: true, position: 'bl' }
        : undefined;

    const dropdownMenuClassName = twoLine ? "item-select-popup" : undefined;

    const renderFormat = twoLine
        ? (option) => option?.extra?.itemName || ''
        : undefined;

    return (
        <Select
            {...props}
            showSearch
            filterOption={filterOption}
            options={data}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            renderFormat={renderFormat}
            triggerProps={triggerProps}
            dropdownMenuClassName={dropdownMenuClassName}
        />
    );
}